<template>
  <v-layout align-start>
    <v-flex>
      <v-card elevation="0">
        <v-card-title>
          Solicitudes AR
          <v-divider vertical inset class="mx-4"></v-divider>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                icon
                large
                color="green"
                @click="listar()"
                v-bind="attrs"
                v-on="on"
                ><v-icon class="fa fa-sync-alt"></v-icon
              ></v-btn>
            </template>
            <span>Actualizar</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-text-field
            v-if="itemSolicitud.length > 0"
            v-model="search"
            label="Buscador"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-data-table
          v-if="itemSolicitud.length > 0"
          :headers="headers"
          :items="itemSolicitud"
          :search="search"
          no-data-text="No hay datos"
          calculate-widths
          disable-pagination
          sort-by="Fecha"
        ></v-data-table>
        <v-row align="center" justify="center" v-if="itemSolicitud.length <= 0">
          <v-col cols="auto">
            <div class="text-center font-weight-bold display-1">
              Sin datos...
            </div>
            <lottie-player
              src="https://assets9.lottiefiles.com/packages/lf20_dx5nwnnb.json"
              background="transparent"
              speed="1"
              style="width: 250px; height: 250px"
              loop
              autoplay
            ></lottie-player>
          </v-col>
        </v-row>
        <!-- PreLoader -->
        <v-overlay v-model="overlay" z-index="0">
          <lottie-player
            v-if="true"
            src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
            background="transparent"
            speed="1"
            style="width: 300px; height: 300px"
            loop
            autoplay
          ></lottie-player>
        </v-overlay>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { dbRealtimeSolicitudInformacionAR } from "../main";
export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "Fecha", value: "Fecha", align: 'center' },
        { text: "Nombre", value: "Nombre", align: 'center' },
        { text: "Apellido", value: "Apellido", align: 'center' },
        { text: "Correo", value: "Correo", align: 'center' },
        { text: "Telefono (Opcional)", value: "Telefono", align: 'center' },
        { text: "Comentario (Opcional)", value: "Comentario", align: 'center' },
      ],
      itemSolicitud: [],
      overlay: false,
    };
  },

  created() {
    this.listar();
  },

  methods: {
    listar() {
      this.overlay = true;
      dbRealtimeSolicitudInformacionAR
        .child("Solicitudes")
        .on("value", (dataSnapShot) => {
          this.itemSolicitud = [];
          dataSnapShot.forEach((element) => {
            this.itemSolicitud.push({
              Fecha: element.val().Fecha,
              Nombre: element.val().Nombre,
              Apellido: element.val().Apellido,
              Correo: element.val().Correo,
              Telefono: element.val().Telefono,
              Comentario: element.val().Comentario,
            });
          });
          this.overlay = false;
        });
    },
  },
};
</script>
